// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1m97f","question":"Question_question__311jJ","description":"Question_description__2RttQ"};